var ui = {
  addToCart: '[action="/cart/add"]',
  cart: '.fa-shopping-cart',
  isSample: '.is-sample',
  hasProduct: '.product-info h5',
  navToggle: document.querySelector('.navbar-toggle'),
  cartTranslated: document.querySelector('[data-cart-text]').getAttribute('data-cart-text'),
  closeTranslated: document.querySelector('[data-layout-close]').getAttribute('data-layout-close'),
  generalMenu: document.querySelector('.generalMenu').textContent,
  productFinder: document.querySelector('.guidelines-product-finder'),
  productResults: document.querySelector('.pf-product-results'),
  reviews: document.getElementById('pr-reviewdisplay'),
  promoHeader: document.querySelector('.navbar .preheader')
}

Vue.component('modal', {
  props: [
    'productImage',
    'productHandle',
    'productSubtitle',
    'productPrice',
    'itemCount',
    'totalPrice'
  ],
  template: '#modal-template'
})

var bus = new Vue()

// start app
var modal = new Vue({
  el: '#app',
  data: {
    showModal: false,
    productImage: null,
    productHandle: null,
    productSubtitle: null,
    productPrice: null,
    itemCount: 0,
    totalPrice: ''
  },
  created: function created() {
    bus.$on(
      'addToCart',
      function(product) {
        this.productImage = product.productImage
        this.productHandle = product.productHandle
        this.productSubtitle = product.productSubtitle
        this.productPrice = product.productPrice
        this.itemCount = product.itemCount
        this.totalPrice = product.totalPrice
      }.bind(this)
    )
  }
})

var hasAddToCart = isInPage(document.querySelector(ui.addToCart))
var hasProduct = isInPage(document.querySelector(ui.hasProduct))
var hasPromoHeader = isInPage(ui.promoHeader)

if (hasPromoHeader) {
  var holidayText = 'Complimentary Sample with Purchase. Free US 2-Day Shipping.'
  var dateObj = new Date()
  var month = dateObj.getUTCMonth() + 1 // months from 1-12
  var day = dateObj.getUTCDate()
  var year = dateObj.getUTCFullYear()

  var is2018 = year === 2018
  var isDecember = month === 12
  var isDayRange = day >= 17 && day < 22

  var ShowHolidayText = is2018 && isDecember && isDayRange
  if (ShowHolidayText) ui.promoHeader.querySelector('p').textContent = holidayText

  ui.promoHeader.style.display = 'block'
}

if (hasAddToCart) {
  forEachEl(ui.addToCart, function(form) {
    form.addEventListener('submit', function(e) {
      if (!isInPage(document.querySelector(ui.isSample))) {
        e.preventDefault()
        var opts = {
          method: 'POST',
          api: '/cart/add.js',
          form: form
        }
        shopifyApi(opts, function(err, data) {
          if (err) return console.error(err)
          shopifyApi({ api: '/cart.js' }, function(err, data) {
            if (err) return console.error(err)

            forEachEl(ui.cart, function(cartUI) {
              var cart = JSON.parse(data)
              var html = cartUI.outerHTML
              var cartUIContainer = html + '(' + String(cart.item_count++) + ')' // + ui.cartTranslated
              cartUI.parentNode.innerHTML = cartUIContainer
              itemCount = cart.itemCount
            })

            var btn = form.querySelector('.addtocart')
            if (!isInPage(btn)) return
            btn.value = btn.getAttribute('data-added')
            btn.className += ' btn-disabled'

            btn.setAttribute('disabled', true)
            var shopItem = form.parentNode
            var productHandle = shopItem.querySelector('.item-title a').textContent
            var productSubtitle = shopItem.querySelector('.item-subtitle em')
              ? shopItem.querySelector('.item-subtitle em').textContent
              : ''
            var productPrice = shopItem.querySelector('.item-subtitle strong').textContent
            var productImage = shopItem.querySelector('img').src
            // productHandle = productHandle.replace(/\s+/g, '-')
            // var apiUrl = '/products/' + productHandle + '.js'
            // jQuery.getJSON(apiUrl, function(product) {
            //   console.log(product)
            // })
            var cartData = JSON.parse(data)
            var payload = {}
            payload.productHandle = productHandle
            payload.productSubtitle = productSubtitle
            payload.productPrice = productPrice
            payload.productImage = productImage
            payload.itemCount = cartData.item_count
            payload.totalPrice = Shopify.formatMoney(cartData.total_price)
            bus.$emit('addToCart', payload)
          })
        })
      }
    })
  })
}

if (hasProduct) {
  var product = document.querySelector(ui.hasProduct)
  var isFreeSample = product.textContent.indexOf('Sample') > -1

  if (isFreeSample) {
    document.querySelector('.cart-sample-cta').innerHTML = ''
  }
}

var toggled = false
var toggleSpan = ui.navToggle.querySelector('span')
ui.navToggle.addEventListener('click', function() {
  if (!toggled) {
    toggleSpan.textContent = ui.closeTranslated + ' [x]'
  } else {
    toggleSpan.textContent = ui.generalMenu
  }

  toggled = !toggled
})

function MobileNav(element, options) {
  if (!element) {
    return
  }

  this.element = element
  this.closeBtn = options.closeBtn
  this.topLevelListItem = options.topLevelListItem
  this.topLevelListItem_child = options.topLevelListItem_child
  this.topLevelLink = options.topLevelLink
  this.topLevelLinkChild = options.topLevelLinkChild
  this.dropdown = options.dropdown
  this.dropdownChild = options.dropdownChild
}

MobileNav.prototype.init = function() {
  if (!this.element) {
    return
  }
  this.attachEvents()
}

MobileNav.prototype.attachEvents = function () {
  var self = this

  $(this.topLevelLink).on('click', function (e) {
    var dropdown = $(this).parents(self.topLevelListItem).find(self.dropdown)
    if (dropdown.length) {
      $(this).toggleClass('isActive')
      $(this).parents(self.topLevelListItem).find(self.dropdown).slideToggle('fast')
      return false
    }
  })
  
  $(this.topLevelLinkChild).on('click', function (e) {
    var dropdownChild = $(this).parents(self.topLevelListItem_child).find(self.dropdownChild)
    if (dropdownChild.length) {
      $(this).toggleClass('isActive')
      $(this).parents(self.topLevelListItem_child).find(self.dropdownChild).slideToggle('fast')
      return false
    }
  })
}

var mobileNav = new MobileNav('.mobileNav', {
  closeBtn: '.mobileNav__closeBtn',
  topLevelListItem: '.mobileNav__listItem',
  topLevelListItem_child: '.mobileNav__listItem_child',
  topLevelLink: '.mobileNav__link span',
  topLevelLinkChild: '.mobileNav__linkChild span',
  dropdown: '.mobileNav__dropdown',
  dropdownChild: '.mobileNav__dropdown_child'
})

mobileNav.init()

function shopifyApi(opts, cb) {
  if (!opts) opts = {}
  var xhr = new XMLHttpRequest()

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) cb(null, xhr.responseText)
      else cb('We reached our target server, but it returned an error')
    }
  }

  xhr.open(opts.method || 'GET', opts.api)

  var data = opts.method === 'POST' ? new FormData(opts.form) : null

  xhr.send(data)
}

function forEachEl(el, cb) {
  ;[].forEach.call(document.querySelectorAll(el), cb)
}

function isInPage(node) {
  return node === document.body ? false : document.body.contains(node)
}


// product selector

var productMsgs = {
  'BIOEFFECT EGF Serum':
    '<strong>2-4 Drops is all you need</strong> </br> Scientifically proven to minimize fine lines and wrinkles, this product contains only 7 ingredients with no preservatives or additives. Our award winning bestseller for a reason.',
  'BIOEFFECT EGF Day Serum':
    '<strong>Your Perfect Primer</strong> </br> Kickstart your day and keep your skin young with the EGF Day Serum, equipped with multiple anti-aging benefits restoring your skin’s moisture balance from sunrise to sunset. An ideal primer for your makeup, this must have will keep you looking (and feeling) your best.',
  'BIOEFFECT EGF + 2A DAILY Duo':
    '<strong>Fight Free Radical</strong> </br> Did you know environmental factors can be just as damaging to your skin as UV rays? This 2 step process is a must have for any city girl, sun goddesses and cold weather lovers alike, equipped with a precise, layered application that fights the aging effects of pollution while also minimizing fine lines and wrinkles. Win-win.',
  'BIOEFFECT 30 Day Treatment':
    '<strong>Bootcamp for your skin </strong> </br> Everyone needs a kickstart, and your skin is no different! To be used only 1-4 times a year, this revolutionary 30 Day Treatment is equipped with intensive age-defying cellular activators to revive and restore your skin, when you need it most.',
  'BIOEFFECT EGF Eye Serum':
    '<strong>Cooling roller applicator</strong> </br> Our eyes often show the first signs of aging. But not anymore. Our powerful Eye Serum is specifically formulated for this delicate skin, minimizing fine lines and wrinkles with a feather light finish that leaves your eyes radiant, firm, and dark circle free.',
  'BIOEFFECT EGF Eye Mask Treatment':
    '<strong>Instant, visible results</strong> </br> Long night? Early morning? With our EGF Eye Masks, puffiness and dark circles are things of the past. Equipped with a high concentration of our plant-based EGF, our eye serum treatment works in tandem with a hydrogel patch, encouraging more EGF activity which means more firmness with every use.',
  'BIOEFFECT Daytime Moisturizer':
    '<strong>Luxuriously Soft</strong> </br> Our age-defying moisturizer improves your skin’s tone and texture and absorbs easily into the skin leaving it looking youthful and nourished. A necessity for mornings or nights, this daytime moisturizer is not your everyday face cream.',
  'BIOEFFECT Volcanic Exfoliator':
    '<strong>With micro-crystalline lava</strong> </br> When we say “Born From Science, Made in Iceland” we mean it. This volcanic exfoliator contains all natural Icelandic micro-crystalline lava, an ingredient that helps to give your skin a deep cleaning that leaves your face feeling soft and refreshed.',
  'BIOEFFECT Micellar Cleansing Water':
    '<strong>Pure, Soft, Icelandic Water</strong> </br> The Micellar Cleansing Water stands apart from others due to its unique, base ingredient: pure, soft, Icelandic water. Along with four hydrating agents to moisturize the skin, the star ingredients are the cleansing micelles, magnets for oil and dirt that remove them from your skin without leaving any residue.',
  'BIOEFFECT OSA Water Mist':
    '<strong>Lasting Hydration</strong> </br> Made with pure, geologically filtered Icelandic water, our mist hydrates and balances the skin, easing dryness and discomfort. Containing orthosilicic acid (OSA) which is a bioavailable form of silica and optimized hyaluronic acid, this mist strengthens your skin and gives around the clock hydration.'
//   'EGF Serum Special Edition':
//   	'<strong></strong><br />This year BIOEFFECT is celebrating the science behind our unique ingredient EGF (Epidermal Growth Factor) and the Special Edition pairs our award-winning bestseller, BIOEFFECT EGF Serum, with luxury sample of BIOEFFECT Body Intensive. This powerful duo provides you with a great EGF routine for face and body.'
}

var first = true

if (isInPage(ui.productFinder)) {
  var obs = watch(ui.productFinder, function(node) {
    if (first) {
      ;[].forEach.call(document.querySelectorAll('.pf-answer'), function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault()
          setTimeout(function() {
            // console.log(window.pageYOffset < 250, window.pageYOffset)
            // if (window.pageYOffset < 250) return
            $('html,body').animate(
              {
                scrollTop: 0
              },
              750
            )
          }, 150)
        })
      })
    }

    first = false

    if (node.getAttribute && node.getAttribute('class') === 'pf-product-wrapper') {
      // obs.disconnect()
      var section = document.querySelector('.section-page')
      var prev = section.style.backgroundImage
      var imgUrl = section.getAttribute('data-results-bg')
      section.style.backgroundImage = 'url(' + imgUrl + ')'
      Object.keys(productMsgs).forEach(function(product) {
        var result = document.querySelector('.pf-results-link[data-title="' + product + '"]')
        if (isInPage(result)) {
          var details = result.parentNode.parentNode.querySelector('.pf-results-details')
          var href = details.querySelector('.pf-results-link').getAttribute('href')
          details.innerHTML += '<p class="pf-results-description">' + productMsgs[product] + '</p>'
          details.innerHTML +=
            '<div onclick="resultClick(\'' +
            href +
            '\')" class="btn btn-solid pf-buy-btn">Buy Now</div>'
        }
      })

      var end = document.querySelector('.pf-results-row')
      end.innerHTML +=
        '<a href="https://bioeffect.com/pages/bioeffects-daily-regimen-selector" class="btn btn-solid" style="color: #000;">Take the Quiz Again</a>'

      document.querySelector('.pf-back-link').addEventListener('click', function() {
        section.style.backgroundImage = prev
        prev = imgUrl
      })
    }
  })
}

if (isInPage(ui.reviews)) {
  var obs = watch(ui.reviews, function() {
    document.querySelector('.pr-headline').textContent = 'Reviews'
    ;[].forEach.call(document.querySelectorAll('.pr-star-v4'), function(el) {
      el.removeAttribute('aria-checked')
      el.removeAttribute('tabindex')
      el.removeAttribute('role')
    })
    obs.disconnect()
  })
}

function watch(el, cb) {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (!mutation.addedNodes) return

      for (var i = 0; i < mutation.addedNodes.length; i++) {
        // do things to your newly added nodes here
        var node = mutation.addedNodes[i]

        cb(node)
      }
    })
  })

  observer.observe(el, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  })

  // stop watching using:
  return observer
}

window.resultClick = function(href) {
  window.location = href
}

var giftCardDropDown = document.querySelector('.giftCard__dropdown')
var giftCards = document.querySelector('.giftCardList__container')
var dropped = false

if (isInPage(giftCardDropDown)) {
  giftCardDropDown.addEventListener('click', function() {
    if (!dropped) {
      giftCards.style.display = 'block'
      giftCardDropDown.querySelector('p').textContent = 'hide other gift card amounts ↑'
      dropped = true
    } else {
      giftCards.style.display = 'none'
      giftCardDropDown.querySelector('p').textContent = 'show other gift card amounts ↓'
      dropped = false
    }
  })
}

function triggerModal() {
  if (hasAddToCart) {
    forEachEl('.addtoCart', function(el) {
      console.log(el)
      var id = el.parentNode.querySelector('input[name=id]')
      console.log(id)
    })
  }
}

$.fn.swap = function (elem) {
    elem = elem.jquery ? elem : $(elem);
    return this.each(function () {
        $(document.createTextNode('')).insertBefore(this).before(elem.before(this)).remove();
    });
};

function getSetVariant(param) {
  var getVariantId = $(param).attr('data-value');
  var getVariantTitle = $(param).attr('data-variant-title');
  var getVariantPrice = $(param).attr('data-price');
  var getVariantImagePath = $(param).attr('data-image');
  
//   Settings value to input for adding to cart product with this variant
  $('#getVariantDetails').attr('value', getVariantId);
  $('.section-product .product-select').attr('value', getVariantId);
  
//   Settings Image of Variant When selected
  $('.main-p-image .active.in > img').attr('src', getVariantImagePath);
  
//   On clicking variant change the class and variant title
  if(!$(param).hasClass('selected')) {
	$(param).addClass('selected').siblings().removeClass('selected');
    $('.mobile-tabs-list li:nth-child(3)').swap('.mobile-tabs-list li:last-child');
    $('.variant-txt-title p').text(getVariantTitle);
    $('.price-box .item-price').text(getVariantPrice);
  }
}